'use client';
import { TranslationMessages } from 'ra-core';

const de: TranslationMessages = {
    ra: {
        action: {
            add_filter: 'Filter zufügen',
            add: 'Hinzufügen',
            back: 'Zurück',
            bulk_actions: '1 Zeile ausgewählt |||| %{smart_count} Zeilen ausgewählt',
            cancel: 'Abbrechen',
            clear_array_input: 'Liste löschen',
            clear_input_value: 'Leeren',
            clone: 'Klonen',
            confirm: 'Bestätigen',
            create: 'Erstellen',
            create_item: 'Erstelle %{item}',
            delete: 'Löschen',
            edit: 'Bearbeiten',
            export: 'Exportieren',
            list: 'List',
            refresh: 'Neu laden',
            remove_filter: 'Filter löschen',
            remove_all_filters: 'Alle Filter löschen',
            remove: 'Entfernen',
            save: 'Speichern',
            search: 'Suchen',
            select_all: 'Alle auswählen',
            select_row: 'Zeile auswählen',
            show: 'Anzeigen',
            sort: 'Sortieren',
            undo: 'Zurück',
            unselect: 'Unselect',
            expand: 'Expand',
            close: 'Schließen',
            open_menu: 'Menü öffnen',
            close_menu: 'Menü schließen',
            update: 'Update',
            move_up: 'Move up',
            move_down: 'Move down',
            open: 'Öffnen',
            toggle_theme: 'Toggle Theme',
            select_columns: 'Spalten',
            update_application: 'Neu laden',
        },
        boolean: {
            true: 'Ja',
            false: 'Nein',
            null: ' ',
        },
        page: {
            create: 'Erstelle %{name}',
            dashboard: 'Dashboard',
            edit: '%{name} %{recordRepresentation}',
            error: 'Etwas ist schief gelaufen',
            list: '%{name}',
            loading: 'Lädt',
            not_found: 'Nicht gefunden',
            show: '%{name} %{recordRepresentation}',
            empty: 'Keine %{name} bisher.',
            invite: 'Willst du einen neuen Datensatz erstellen?',
        },
        input: {
            file: {
                upload_several:
                    'Drop some files to upload, or click to select one.',
                upload_single: 'Ziehe eine Datei in das Feld, oder klicke hier um eine Datei auszwählen.',
            },
            image: {
                upload_several:
                    'Drop some pictures to upload, or click to select one.',
                upload_single:
                    'Ziehe ein Bild in das Feld, oder klicke hier um eins auszwählen.',
            },
            references: {
                all_missing: 'Keine Daten vorhanden.',
                many_missing:
                    'At least one of the associated references no longer appears to be available.',
                single_missing:
                    'Associated reference no longer appears to be available.',
            },
            password: {
                toggle_visible: 'Hide password',
                toggle_hidden: 'Show password',
            },
        },
        message: {
            about: 'About',
            are_you_sure: 'Bist du sicher?',
            auth_error:
                'An error occurred while validating the authentication token.',
            bulk_delete_content:
                'Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?',
            bulk_delete_title:
                'Delete %{name} |||| Delete %{smart_count} %{name}',
            bulk_update_content:
                'Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?',
            bulk_update_title:
                'Update %{name} |||| Update %{smart_count} %{name}',
            clear_array_input: 'Wollen Sie alle Elemente in der Liste löschen?',
            delete_content: 'Bist du sicher, dass du diesen Datensatz löschen willst?',
            delete_title: 'Lösche %{name}',
            details: 'Details',
            error:
                "A client error occurred and your request couldn't be completed.",

            invalid_form: 'Das Formular ist unvollständig. Bitte prüfe die Eingabe.',
            loading: 'The page is loading, just a moment please',
            no: 'No',
            not_found:
                'Either you typed a wrong URL, or you followed a bad link.',
            yes: 'Yes',
            unsaved_changes:
                "Some of your changes weren't saved. Are you sure you want to ignore them?",
        },
        navigation: {
            no_results: 'Keine Ergebnisse',
            no_more_results:
                'The page number %{page} is out of boundaries. Try the previous page.',
            page_out_of_boundaries: 'Page number %{page} out of boundaries',
            page_out_from_end: 'Cannot go after last page',
            page_out_from_begin: 'Cannot go before page 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
            partial_page_range_info:
                '%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}',
            current_page: 'Seite %{page}',
            page: 'Zur Seite %{page}',
            first: 'Zur ersten Seite',
            last: 'Zur letzten Seite',
            next: 'Zur nächsten Seite',
            previous: 'Zur vorherigen Seite',
            page_rows_per_page: 'Zeilen pro Seite:',
            skip_nav: 'Skip to content',
        },
        sort: {
            sort_by: 'Sortieren nach %{field} %{order}',
            ASC: 'aufstiegend',
            DESC: 'absteigend',
        },
        auth: {
            auth_check_error: 'Bitte loggen Sie sich ein.',
            user_menu: 'Profile',
            username: 'Username',
            password: 'Passwort',
            sign_in: 'Login',
            sign_in_error: 'Authentication failed, please retry',
            logout: 'Logout',
        },
        notification: {
            updated: 'Element aktualisiert |||| %{smart_count} Elemente aktualisiert',
            created: 'Element erstellt',
            deleted: 'Element gelöscht |||| %{smart_count} Elemente gelöscht',
            bad_item: 'Falsche Element',
            item_doesnt_exist: 'Element existiert nicht',
            http_error: 'Server Fehler',
            data_provider_error:
                'Datenprovider Fehler. Bitte schaue in der Konsole nach.',
            i18n_error:
                'Cannot load the translations for the specified language',
            canceled: 'Aktion abgebrochen',
            logged_out: 'Your session has ended, please reconnect.',
            not_authorized: "You're not authorized to access this resource.",
            application_update_available: 'A new version is available.'
        },
        validation: {
            required: 'Pflichtfeld',
            minLength: 'Sollte mindestens %{min} Zeichen lang sein',
            maxLength: 'Sollte höchstens %{max} Zeichen lang sein',
            minValue: 'Must be at least %{min}',
            maxValue: 'Must be %{max} or less',
            number: 'Muss eine Nummer sein',
            email: 'Bitte eine gültige Emailadresse eingeben',
            oneOf: 'Must be one of: %{options}',
            regex: 'Must match a specific format (regexp): %{pattern}',
        },
        saved_queries: {
            label: 'Gespeicherte Abfragen',
            query_name: 'Anfrage name',
            new_label: 'Abfrage speichern...',
            new_dialog_title: 'Abfrage speichern als',
            remove_label: 'Gespeicherte Abfrage löschen',
            remove_label_with_name: 'Lösche Abfrage "%{name}"',
            remove_dialog_title: 'Abfrage löschen?',
            remove_message:
                'Bist Du sicher, dass Du diese Abfrage löschen wollen?',
            help: 'Filter the list and save this query for later',
        },
        configurable: {
            customize: 'Customize',
            configureMode: 'Configure this page',
            inspector: {
                title: 'Inspector',
                content: 'Hover the application UI elements to configure them',
                reset: 'Reset Settings',
                hideAll: 'Hide All',
                showAll: 'Show All',
            },
            Datagrid: {
                title: 'Datagrid',
                unlabeled: 'Unlabeled column #%{column}',
            },
            SimpleForm: {
                title: 'Form',
                unlabeled: 'Unlabeled input #%{input}',
            },
            SimpleList: {
                title: 'List',
                primaryText: 'Primary text',
                secondaryText: 'Secondary text',
                tertiaryText: 'Tertiary text',
            },
        },
    },
    resources: {
        drafts: {
            name: 'Entwurf |||| Entwürfe',
            actions: {
                create: "Entwurf speichern"
            },
            notifications: {
                created: "Entwurf gespeichert"
            }
        },
        numberRanges: {
            name: 'Nummernkreis |||| Nummernkreise',
            title: 'Name',
            value: 'Prefix',
            firstNumber: 'Erste Nummer',
            nextNumber: 'Nächste Nummer',
            isUsed: 'Verwendet',
            isDefault: 'Standard',
            dialogs: {
                markAsDefault: 'Als Standard auswählen',
                add: "Bitte lege einen Nummernkreis an"
            },
            actions: {
                select: 'Auswählen',
                add: "Anlegen"
            },
            notifications: {
                markedAsDefault: '%{title} wurde als Standard markiert'
            }
        },
        uploadedIncomingInvoices: {
            name: 'Eingangsrechnung |||| Eingangsrechnungen'
        },
        uploadedOutgoingInvoices: {
            name: 'Ausgangsrechnung |||| Ausgangsrechnungen'
        },
        uploadedInvoices: {
            name: 'Buchungssatz |||| Buchungssätze',
            incoming: 'Eingangsrechnungen',
            outgoing: 'Ausgangsrechnungen',
            accountId: 'Buchungskonto',
            reverseAccountId: 'Vorgang',
            invoiceDate: 'Rechnungsdatum',
            bookingType: 'Buchungsart',
            amount: 'Betrag',
            taxInPercent: 'USt',
            invoiceNumber: 'Rechnungsnummer',
            ustId: 'UstId',
            carId: 'Fahrzeug',
            businessPartnerId: 'Geschäftspartner',
            dialogs: {
                book: "Willst du die Rechnung buchen? |||| Willst du %{smart_count} Rechnungen buchen?",
                create: "Buchungssätze erstellen",
                upload: "Rechnungen importieren"
            },
            actions: {
                book: "Buchen",
                bookAndAdd: "Buchen und weiter",
                create: "Belegupload",
                upload: "Rechnungen importieren"
            },
            notifications: {
                booked: "Die Rechnung wurde gebucht",
                created: "Buchungssätze erstellt",
                uploaded: "Rechnung wurde importiert |||| %{smart_count} Rechnungen wurden importiert"
            }
        },
        reverseInvoices: {
            name: 'Stornorechnung |||| Stornorechnungen',
            heading: 'Bezeichnung',
            isSendByMail: "Vesendet",
            isBooked: "Gebucht",
            dialogs: {
                send: "Willst du die Stornorechnung als Email senden?",
            },
            actions: {
                send: "Senden",
            },
            notifications: {
                sent: "Die Stornorechnung wurde gesendet",
            }
        },
        invoices: {
            name: 'E-Rechnung |||| E-Rechnungen',
            grossAmount: 'Betrag [brutto]',
            netAmount: 'Betrag [netto]',
            taxAmount: 'USt',
            totalAmount: 'Betrag',
            comment: "Kommentar |||| Kommentare",
            childDocuments: "Verknüpfte Dokumente",
            parentDocument: "Verknüpfte Rechnung",
            invoiceDate: 'Rechnungsdatum',
            invoiceState: 'Status',
            invoiceType: 'Rechnungsart',
            pending: 'Offen',
            pastDue: 'Fällig',
            paid: 'Bezahlt',
            failed: 'Abgebrochen',
            canceled: 'Storniert',
            dueDate: 'Zahlungsfrist',
            invoiceNumber: 'Rechnungsnummer',
            reverseInvoiceNumber: 'Stornonummer',
            createdAt: 'Rechnungsdatum',
            isSendByMail: 'Versendet',
            isCanceled: 'Storniert',
            isBooked: 'Gebucht',
            numberRange: 'Nummernkreis',
            carId: 'Fahrzeug',
            bookingPeriod: 'Buchungszeitraum',
            bookingInfo: {
                bookingNumber: '#',
                bookingPeriodName: 'Zeitraum',
                amount: 'Betrag',
                bookingText: 'Text',
                bookingDate: 'Datum',
                taxInPercent: 'Steuer'
            },
            form: {
                invoiceType: 'Rechnungstyp',
                numberRange: 'Nummernkreis',
                invoiceAdress: 'Rechnungsadresse',
                textTemplates: 'Textbausteine',
                items: 'Rechnungsposten'
            },
            dialogs: {
                create: "Willst du diese %{invoiceType} erstellen?",
                cancel: "Willst du diese Storno-Rechnung erstellen?",
                send: "Willst du die Rechnung als Email senden?",
                createInvoiceReminder: "Willst du eine Mahnung erstellen?",
                createInvoiceReminderBulk: "Willst du eine Mahnung erstellen? |||| Willst du %{smart_count} Mahnungen erstellen?",
                sendInvoiceReminder: "Willst du die Mahnung senden?",
                book: "Willst Du die Rechnung buchen?",
                invalidPeriod: "Die Rechnung liegt ausserhalb des Buchungszeitraums. ",
                invalidItems: "Die Rechnungspositionen dürfen nicht 0 sein. ",
                alreadyBooked: "Die Rechnung wurde bereits gebucht. ",
                correlationInvoiceNotBooked: "Du musst zuerst die stornierte Rechnung buchen",
                car: "Bitte wähle ein Fahrzeug",
                noTaxWarning: "Hinweis: Auf der Rechnung wird mit den aktuellen Einstellungen weder eine Steuernummer noch eine UStId angezeigt.",
                alreadyCanceled: "Die Rechnung wurde bereits storniert.",
                addComment: "Kommentar erstellen",
                removeComment: "Wollen Sie diesen Kommentar löschen?",
                invalidStateChange: "Eine Rechnung im Status %{actualState} darf nicht auf den Status %{newState} gesetzt werden.",
                alreadyThatState: "Diese Rechnung ist bereits im Status %{actualState}."
            },
            actions: {
                cancel: "Stornieren",
                download: "Export",
                send: "Senden",
                createInvoiceReminder: "Mahnung erstellen",
                createInvoiceReminderBulk: "Mahnung erstellen |||| %{smart_count} Mahnungen erstellen",
                sendInvoiceReminder: "Mahnen",
                create: "Rechnung erstellen",
                book: "Rechnung buchen",
                back: "Zur Buchhaltung",
                addComment: "Kommentar erstellen",
                removeComment: "Kommentar löschen"
            },
            notifications: {
                canceled: "Rechnung wurde storniert",
                downloaded: "Rechnung wurde als ZUGFeRD-PDF exportiert",
                invoiceStateChanged: "Der Rechnungsstatus wurde geändert",
                sent: "Die Rechnung wurde gesendet",
                invoiceReminderCreated: "Die Mahnung wurde erstellt",
                invoiceReminderSent: "Die Mahnung wurde gesendet",
                created: "Die Rechnung wurde erstellt",
                booked: "Die Rechnung wurde gebucht",
                bookingDenied: "Die Rechnung kann leider nicht gebucht werden.",
                commentAdded: "Der Kommentar wurde erstellt.",
                commentRemoved: "Der Kommentar wurde gelöscht."
            },
            bulkActions: {
                book: {
                    label: "Buchen",
                    confirmTitle: "%{smart_count} Rechnung buchen |||| %{smart_count} Rechnungen buchen",
                    confirmBody: "%{smart_count} Rechnung ausgewählt. |||| %{smart_count} Rechnungen ausgewählt.",
                    irreversibilityHint: "Buchungen sind nur aufwendig rückgängig zu machen.",
                    breakdownTitle: "Übersicht der Auswahl",
                    breakdown: {
                        bookable: "Buchbar"
                    },
                    reason: {
                        alreadyBooked: "Bereits gebucht",
                        saleCarInvoice: "Fahrzeugverkauf (manuelle Auto-Auswahl nötig)",
                        invalidPeriod: "Außerhalb des Buchungszeitraums",
                        invalidItems: "Ungültige Rechnungspositionen",
                        backendError: "Fehler beim Buchen",
                        notLoaded: "Nicht in der aktuellen Ansicht geladen"
                    },
                    summaryTitle: "Buchungs-Zusammenfassung",
                    summaryBody: "%{success} von %{total} Rechnungen erfolgreich gebucht.",
                    errorsTitle: "Übersprungen / fehlgeschlagen",
                    loadError: "Rechnungen konnten nicht geladen werden."
                }
            }
        },
        invoiceReminders: {
            name: "Mahnung |||| Mahnungen",
            invoiceReminderDate: "Datum",
            isSendByMail: "Versendet",
            heading: "Bezeichnung"
        },
        textTemplates: {
            name: 'Textbaustein |||| Textbausteine',
            textModelEmail: 'Emailtexte',
            textMode: 'Rechnungstexte',
            title: 'Name',
            text: 'Text',
            textType: 'Textart',
            isDefault: 'Standard',
            setToDefault: 'Auf Standard setzen',
            introduction: 'Begrüßungstext',
            terms: 'Konditionstext',
            ending: 'Schlusstext',
            isSmallBusinessNotice: 'Hinweis Kleinunternehmer',
            reverseChargeNotice: 'Hinweis Reverse-Charge-Verfahren',
            deliveryDateNotice: 'Hinweis Leistungsdatum',
            sendInvoiceEmailText: 'Rechnung senden',
            sendReverseInvoiceEmailText: 'Stornorechnung senden',
            sendInvoiceReminderEmailTextStep1: 'Zahlungserinnerung senden',
            sendInvoiceReminderEmailTextStep2: '1. Mahnung senden',
            sendInvoiceReminderEmailTextStep3: 'Weitere Mahnungen senden',
            action: {
                showTextModel: "Rechnungstexte konfigurieren",
                showTextModelEmail: "Emailtexte konfigurieren",
                hideTextModel: "Standardtexte übernehmen"
            },
        },
        filter: {
            companyNameContains: 'Kunde/Firma',
            invoiceNumberContains: 'Rechnungsnummer',
            contactEmailContains: 'Email',
            productNameContains: 'Bezeichnung',
            fileNameContains: 'Dateiname',
            nameContains: 'Name',
            grossAmountGt: 'Betrag >=', 
            grossAmountLt: 'Betrag <=', 
            invoiceDateGt: 'Rechnungsdatum >=',
            invoiceDateLt: 'Rechnungsdatum <=',
            dueDateGt: 'Zahlungsfrist >=',
            dueDateLt: 'Zahlungsfrist <=',
            isSendByMail: 'Versendet',
            invoiceStateEq: 'Status',
            numberRangeIdEq: 'Nummernkreis',
            bookingConfirmed: 'Bereits gebucht',
            bookingInfosEqNull: 'Nur nicht gebuchte'
        },
        contact: {
            name: 'Kontakt',
            gender: 'Anrede',
            male: 'Herr',
            female: 'Frau',
            lastName: 'Nachname',
            firstName: 'Vorname',
            fullName: 'Ansprechpartner',
            email: 'Email',
            phone: 'Telefon'
        },
        company: {
            name: 'Kunde/Firma',
            userCompanyName: 'Name/Firma',
            additionalAddress: 'Zusätzliche Angaben',
            companyName: 'Kunde/Firma',
            street: 'Strasse',
            number: 'Hausnummer',
            postCode: 'PLZ',
            city: 'Stadt',
            country: 'Land',
            email: 'Email',
            localCourt: 'Registergericht',
            hrbNumber: 'Registernummer',
            managingDirector: 'Geschäftsführer',
            website: 'Internetseite'
        },
        logo: {
            name: 'Logo',
            addLogo: 'Logo hinzufügen',
            removeLogo: 'Logo löschen'
        },
        bankAccount: {
            name: 'Bankverbindung',
            bankName: 'Bankname',
            accountOwner: 'Kontoinhaber',
            iban: 'IBAN',
            bic: 'BIC'
        },
        customers: {
            name: 'Kunde |||| Kunden',
            invoices: 'Rechnungen',
            ustId: 'UstId',
            statistic: {
                name: "Umsätze",
                salesNet: "Umsatz [netto]",
                salesGross: "Umsatz [brutto]",
                salesTax: "Umsatz USt"
            },
            message: {
                noEmail: "Der Kunde hat keine Emailadresse"
            }
        },
        users: {
            name: 'Nutzer |||| Nutzer',
            isSmallBusiness: 'Kleinunternehmer',
            defaultDuePeriod: 'Standard Zahlungsfrist [Tage]',
            taxNumber: 'Steuernummer',
            federalState: 'Bundesland',
            ustId: 'UStId',
            isUstIdHidden: 'UStId auf Rechnung ausblenden',
            menu: {
                userData: 'Benutzerdaten',
                subscription: 'Paket'
            },
            message: {
                notComplete: "Bitte vervollständige deine Nutzerdaten",
                noEmail: "Der Nutzer hat keine Emailadresse"
            },
            action: {
                complete: "Vervollständigen"
            }
        },
        mailServiceConfig: {
            name: 'Mail Server',
            email: 'Email',
            sender: 'Sendername',
            userName: 'Benutzername',
            password: 'Passwort',
            host: 'Host',
            port: 'Port',
            useSsl: 'Verbindungssicherheit (SSL/TLS)',
            message: {
                notConfigured: 'Du musst erst eine bestehende Email-Adresse einrichten.',
                success: 'Die Mail konnte versendet werden',
                error: 'Die Mail konnte nicht versendet werden'
            },
            action: {
                configure: 'Email-Adresse einrichten',
                testMail: 'Testmail',
                send: 'Testmail senden'
            }
        },
        products: {
            name: 'Produkt |||| Produkte',
            productName: 'Bezeichnung',
            description: "Beschreibung",
            price: 'Betrag [netto]',
            tax_in_percent: 'USt'
        },
        uploadedFile: {
            fileName: 'Dateiname'
        },
        items: {
            name: 'Rechnungsposten',
            description: 'Beschreibung',
            quantity: 'Anzahl',
        },
        invoiceTypes: {
            standardInvoice: 'Standard Rechnung',
            smallBusinessInvoice: 'Kleinunternehmer Rechnung',
            euInvoiceService: 'EU Rechnung (Dienstleistung)',
            euInvoiceDelivery: 'EU Rechnung (Lieferung)',
            thirdCountryInvoiceService: 'Drittland Rechnung (Dienstleistung)',
            thirdCountryInvoiceDelivery: 'Drittland Rechnung (Lieferung)',
            revenues13bInvoice: 'Erlöse 13b-Rechnung',
            saleCarInvoice: 'Verkauf PKW Rechnung',
            saleCapitalAssetsInvoice: 'Verkauf Anlagevermögen Rechnung'
        },
        common: {
            tax_in_percent: 'USt',
            price: 'Einzelpreis',
            discount_in_percent: 'Rabatt [%]'
        },
        auditTrail: {
            name: "Historie",
            invoiceCreated: "Rechnung erstellt",
            invoiceSent: "Rechnung gesendet",
            invoicePaid: "Rechnung bezahlt",
            invoiceMarkedAsPending: "Rechnungsstatus auf Offen gesetzt",
            invoiceMarkedAsPastDue: "Rechnungsstatus auf Fällig gesetzt",
            invoiceCanceled: "Rechnung storniert",
            commentForInvoiceAdded: "Kommentar erstellt",
            commentForInvoiceRemoved: "Kommentar gelöscht",
            invoiceReminderCreated: "Mahnung erstellt",
            invoiceReminderSent: "Mahnung gesendet",
            reverseInvoiceSent: "Stornorechnung gesendet"
        },
        dashboard: {
            invoices: {
                noContent: "Hier siehst du in Zukunft eine Übersicht deiner Rechnungen.",
                title: "Rechnungen der letzten %{smart_count} Monate",
                facts: {
                    count: "Anzahl Rechnungen:",
                    netSum: "Summe Netto-Betrag:",
                    taxSum: "Summe Steuern:",
                    grossSum: "Summe Brutto-Betrag:"
                }
            },
            auditTrails: {
                noContent: "Hier siehst du in Zukunft deine letzten Aktivitäten.",
                title: "Letzte %{smart_count} Aktivitäten"
            },
            customers: {
                noContent: "Hier behältst du deine Kunden im Blick.",
                title: "Top %{smart_count} Kunden nach Umsatz"
            },
        },
        authentication: {
            login: {
                login: "Login",
                resetPassword: "Passwort vergessen?",
                register: "Hier registrieren.",
                notRegistered: "Noch nicht registriert?",
            },
            sendResetPassword: {
                title: "Passwort vergessen?",
                description: "Wenn du deine Zugangsdaten vergessen haben, trage bitte nachfolgend deinen Benutzernamen oder die E-Mail-Adresse ein, mit der du dich registriert hast. Wir werden dir deine Zugangsdaten dann umgehend erneut an diese Adresse versenden.",
                action: "Passwort zurücksetzen",
                feedback: "In wenigen Minuten bekommst du eine Mail. Bitte klicke auf den Link, um das Passwort zurück zu setzen."
            },
            resetPassword: {
                title: "Neues Passwort",
                description: "Gib bitte ein neues Passwort ein. Das Passwort sollte mindestens 8 Zeichen lang sein.",
                action: "Passwort speichern",
                feedback: "Dein Passwort wurde geändert. Du kannst dich jetzt mit deinem neuen Passwort einloggen."
            },
            register: {
                title: "Registrierung",
                description: "Kostenlos und unverbindlich testen...",
                description1: "Was dich erwartet:",
                action: "Kostenlos registrieren",
                mailings: "(Optional) Ich bin damit einverstanden, dass die freeFiBU GmbH mich frühzeitig per E-Mail über kommende Änderungen an der Software oder den Paketen und Preisen informiert. Meine Einwilligung kann ich jederzeit widerrufen.",
                noTerms: "Du musst unsere AGB sowie die Datenschutzhinweise bestätigen.",
                feedback: "Vielen Dank, die Registrierung wurde versendet. In wenigen Minuten bekommst du eine Mail. Bitte klicke auf den Link, um die Registrierung abzuschließen."
            },
            setupUserLogin: {
                title: "Registrierung abschließen",
                description: "Gib bitte einen Username und ein Passwort ein. Das Passwort sollte mindestens 8 Zeichen lang sein.",
                action: "Passwort speichern"
            }            
        },
        authorization: {
            upgradeDialog: {
                title: "Die Buchhaltung ist in deinem Paket nicht enthalten.",
                description: "Für die Nutzung der Buchhaltung benötigst du ein Buchhaltungs-Paket."
            }
        }
    }
};

export default de;
